export const impactTemplate = [
  { header: 'generateReport.dataToResult.report.general.document_version' },
  { header: 'generateReport.dataToResult.report.general.id_ensaio' },
  { header: 'generateReport.dataToResult.report.general.id_hex' },
  { header: 'generateReport.dataToResult.report.general.product' },
  { header: 'generateReport.dataToResult.report.general.product_version' },
  { header: 'generateReport.dataToResult.report.general.date_authorised' },
  { header: 'generateReport.dataToResult.report.general.observacao_geral' },
  { header: 'generateReport.dataToResult.report.general.text_comentario' },
  { header: 'generateReport.dataToResult.report.general.planta_origem' },
  { header: 'generateReport.dataToResult.report.general.data_cadastro' },
  {
    header:
      'generateReport.dataToResult.report.general.data_liberacao_resultado',
  },
  { header: 'generateReport.dataToResult.report.general.amostra_mes' },
  { header: 'generateReport.dataToResult.report.general.desc_cliente' },
  { header: 'generateReport.dataToResult.report.general.descricao_mes' },
  { header: 'generateReport.dataToResult.report.general.firma_insp' },
  { header: 'generateReport.dataToResult.report.general.pedido' },
  { header: 'generateReport.dataToResult.report.general.item' },
  { header: 'generateReport.dataToResult.report.general.corrida' },
  { header: 'generateReport.dataToResult.report.general.ordem_de_processo' },
  { header: 'generateReport.dataToResult.report.general.lote_tt' },
  { header: 'generateReport.dataToResult.report.general.ippn' },
  { header: 'generateReport.dataToResult.report.general.posicao_amostra' },
  { header: 'generateReport.dataToResult.report.general.id_amostra' },
  { header: 'generateReport.dataToResult.report.test.impact.corpo_de_prova' },
  { header: 'generateReport.dataToResult.report.test.impact.temperatura' },
  { header: 'generateReport.dataToResult.report.test.impact.ea_1' },
  { header: 'generateReport.dataToResult.report.test.impact.ea_2' },
  { header: 'generateReport.dataToResult.report.test.impact.ea_3' },
  { header: 'generateReport.dataToResult.report.test.impact.ea_4' },
  { header: 'generateReport.dataToResult.report.test.impact.ea_5' },
  { header: 'generateReport.dataToResult.report.test.impact.ea_med' },
  { header: 'generateReport.dataToResult.report.test.impact.fd_1' },
  { header: 'generateReport.dataToResult.report.test.impact.fd_2' },
  { header: 'generateReport.dataToResult.report.test.impact.fd_3' },
  { header: 'generateReport.dataToResult.report.test.impact.fd_4' },
  { header: 'generateReport.dataToResult.report.test.impact.fd_5' },
  { header: 'generateReport.dataToResult.report.test.impact.fd_med' },
  { header: 'generateReport.dataToResult.report.test.impact.el_1' },
  { header: 'generateReport.dataToResult.report.test.impact.el_2' },
  { header: 'generateReport.dataToResult.report.test.impact.el_3' },
  { header: 'generateReport.dataToResult.report.test.impact.el_4' },
  { header: 'generateReport.dataToResult.report.test.impact.el_5' },
  { header: 'generateReport.dataToResult.report.test.impact.el_m' },
  { header: 'generateReport.dataToResult.report.test.impact.ea_min' },
  { header: 'generateReport.dataToResult.report.test.impact.ea_med_min' },
  { header: 'generateReport.dataToResult.report.test.impact.fd_min' },
  { header: 'generateReport.dataToResult.report.test.impact.product' },
  { header: 'generateReport.dataToResult.report.test.impact.product_version' },
]
